// extracted by mini-css-extract-plugin
export default {"modalContainer":"DeleteModal_modalContainer__-GZ4y","name":"DeleteModal_name__jZ16N"};